let limit = 60000;
let count = 0;
const interval = setInterval(() => {
    if (typeof $ === "undefined" && typeof jQuery !== "undefined") {
        window.$ = jQuery;
        clearInterval(interval);
    }
    count++;
    if (count > limit) clearInterval(interval);
}, 100);



setTimeout(() => {
    const isCartPage = window.location.pathname === '/cart';
    if (typeof $ === "undefined" && typeof jQuery !== "undefined") {
        window.$ = jQuery;
        clearInterval(interval);
    }
    count++;
    if (count > limit) clearInterval(interval);
    if (!isCartPage) {
        let counter = 0;
        const interval = setInterval(() => {
            let buttonCart = document.querySelector('.wrapper-top-cart')

            if (buttonCart) {
                clearInterval(interval);
                buttonCart.addEventListener('click', () => {
                    setTimeout(() => {
                        handleTEBox();
                    }, 2500);
                });
            }


            counter += 100;
            if (counter >= 10000) {
                clearInterval(interval);
            }

        }, 200);
    } else {
        let counter = 0;
        const interval = setInterval(() => {
            if ($(".bss-b2b-vat-input-wrapper").length > 0) {
                handleTEBox();
                clearInterval(interval);
            } else {
                counter += 100;
                if (counter >= 10000) {
                    clearInterval(interval);
                }
            }
        }, 100);
    }
}, 1000)


function handleTEBox() {
    const translations = BSS_B2B.te.teTranslations;
    const headerText = document.querySelector('.bss-b2b-translation-vat-form_header_text');
    if (headerText) {
        headerText.innerText = translations.form_header_text;
    }

    const subtitleText = document.querySelector('.bss-b2b-translation-vat-form_subtitle_text');
    if (subtitleText) {
        subtitleText.innerText = translations.form_subtitle_text;
    }

    const successMessages = [
        document.querySelector('.bss-b2b-translation-vat-form_success_message'),
        document.querySelector('.bss-b2b-translation-vat-form_success_message_uk'),
        document.querySelector('.bss-b2b-translation-vat-form_success_message_abn'),
        document.querySelector('.bss-b2b-translation-vat-form_success_message_gst'),
        document.querySelector('.bss-b2b-translation-vat-form_success_message_us_ein')
    ];

    successMessages.forEach((msg, index) => {
        if (msg) {
            switch (index) {
                case 0:
                    msg.innerText = translations.form_success_message || '';
                    break;
                case 1:
                    msg.innerText = translations.form_success_message_uk || '';
                    break;
                case 2:
                    msg.innerText = translations.form_success_message_abn || '';
                    break;
                case 3:
                    msg.innerText = translations.form_success_message_gst || '';
                    break;
                case 4:
                    msg.innerText = translations.form_success_message_us_ein || '';
                    break;
            }
        }
    });

    const errorMessages = [
        document.querySelector('.bss-b2b-translation-vat-form_error_message'),
        document.querySelector('.bss-b2b-translation-vat-form_error_message_uk'),
        document.querySelector('.bss-b2b-translation-vat-form_error_message_abn'),
        document.querySelector('.bss-b2b-translation-vat-form_error_message_gst'),
        document.querySelector('.bss-b2b-translation-vat-form_error_message_us_ein'),
        document.querySelector('.bss-b2b-translation-vat-form_validate_country_code_message')
    ];

    errorMessages.forEach((msg, index) => {
        if (msg) {
            switch (index) {
                case 0:
                    msg.innerText = translations.form_error_message || '';
                    break;
                case 1:
                    msg.innerText = translations.form_error_message_uk || '';
                    break;
                case 2:
                    msg.innerText = translations.form_error_message_abn || '';
                    break;
                case 3:
                    msg.innerText = translations.form_error_message_gst || '';
                    break;
                case 4:
                    msg.innerText = translations.form_error_message_us_ein || '';
                    break;
                case 5:
                    msg.innerText = translations.form_validate_country_code_message || '';
                    break;
            }
        }
    });

}